import React, { useCallback } from 'react';
import * as Yup from 'yup';
import { BiImage } from 'react-icons/bi';

import Input from '../../../../../../newComponents/UnformInput';
import FileInput from '../../../../../../newComponents/FileInput';
import Select from '../../../../../../newComponents/UnformSelect';
import TextArea from '../../../../../../newComponents/UnformTextArea';

import { useGridProduct } from '../../../../../../hooks/gridProduct';

import { Container } from './styles';

type DetailsProps = {};

export const DetailsFormSchema = Yup.object().shape({
  group: Yup.number()
    .integer('Grupo inválido')
    .positive('Grupo inválido')
    .required('O grupo é obrigatório'),
  name: Yup.string()
    .max(60, 'No máximo 60 caracteres')
    .required('O nome é obrigatório'),
  observation: Yup.string().max(500, 'No máximo 500 caracteres'),
  gtin: Yup.string(),
  unitOfMeasurement: Yup.number()
    .integer('Unidade de medida inválida')
    .positive('Unidade de medida inválida')
    .required('A unidade de medida é obrigatório'),
});

const Details: React.FC<DetailsProps> = () => {
  const {
    image,
    groupsOptions,
    unitsOfMeasurementOptions,
    handleChangeProduct,
  } = useGridProduct();

  const handleChangeImage = useCallback(
    (imageToChange?: File) => {
      handleChangeProduct({ image: imageToChange });
    },
    [handleChangeProduct],
  );

  return (
    <Container>
      <FileInput
        id="firstGridProductImage"
        icon={BiImage}
        label="Imagem principal"
        title="Escolha uma imagem"
        selectedImage={image}
        acceptableTypes=".jpeg,.jpg,.png"
        subtitle="Formatos: .jpeg, .jpg, .png"
        onRemove={() => handleChangeImage(undefined)}
        onSelectFile={handleChangeImage}
      />
      <Select
        id="gridProductGroup"
        name="group"
        label="Grupo"
        placeholder="Selecione uma opção"
        maxMenuHeight={140}
        options={groupsOptions}
      />
      <Input
        id="gridProductName"
        name="name"
        label="Nome do produto"
        placeholder="Ex.: Lasanha"
      />
      <TextArea
        id="gridProductObservation"
        name="observation"
        label="Descrição"
        placeholder="Ex.: Aproximadamente 700g"
      />
      <Select
        id="gridProductUnitOfMeasurement"
        name="unitOfMeasurement"
        label="Unidade de medida"
        placeholder="Selecione uma opção"
        maxMenuHeight={140}
        options={unitsOfMeasurementOptions}
      />
      <Input
        id="gridProductGtin"
        name="gtin"
        label="Código de barras"
        placeholder="Ex.: 723648234"
      />
    </Container>
  );
};

export default Details;
